import { customerApplicationStatusOptions } from 'Models/Enums/MappedEnumOptions';
import { customerApplicationStatus } from '../../../Models/Enums';

type CustomerApplicationStatusBoxDisplayType = 'square' | 'pill';

export interface CustomerApplicationStatusBoxProps {
    status: customerApplicationStatus;
	displayType?: CustomerApplicationStatusBoxDisplayType;
}

const CustomerApplicationStatusBox = (props: CustomerApplicationStatusBoxProps) => {
	const { status, displayType = 'square' } = props;

	return (
		<span className={`status-box-outline ${status} ${displayType}`}>
			{customerApplicationStatusOptions[status]}
		</span>
	);
};

export default CustomerApplicationStatusBox;